export default __webpack_public_path__ + "static/screen_1_de-52a0dc743cec5f8b56942e9518ebf8f3.jpg";